import { useEffect, useState } from 'react';
import { lightTheme } from '../tokens.js';
/**
 * The side menu's two movements (#742, drawing H1): the current-page band sliding to a new row, and the
 * menu folding from 248 to 56 with its words fading. Both use Fluent's own `durationNormal` and
 * `curveDecelerateMid`; neither moves at all when the person has asked their computer to reduce motion.
 */
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
/** Fluent's `durationNormal` as a number of milliseconds, for the one place a timer has to wait for the fold. */
export const FOLD_MS = Number.parseFloat(lightTheme.durationNormal);
function prefersReducedMotion() {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
        return false;
    return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}
/** True while the person's system asks for reduced motion; follows the setting if it changes while the page is open. */
export function usePrefersReducedMotion() {
    const [reduced, setReduced] = useState(prefersReducedMotion);
    useEffect(() => {
        if (typeof window.matchMedia !== 'function')
            return;
        const query = window.matchMedia(REDUCED_MOTION_QUERY);
        const onChange = () => setReduced(query.matches);
        query.addEventListener('change', onChange);
        return () => query.removeEventListener('change', onChange);
    }, []);
    return reduced;
}
/**
 * What the menu DRAWS while its width follows `expanded`.
 *
 * Folding keeps the words on screen, fading, until the width has narrowed, and only then draws the icon rail.
 * Unfolding draws the words at once and fades them in as the width grows. With reduced motion both are immediate.
 */
export function useFold(expanded, still) {
    const [drawnExpanded, setDrawnExpanded] = useState(expanded);
    const [phase, setPhase] = useState('still');
    const [last, setLast] = useState(expanded);
    if (expanded !== last) {
        setLast(expanded);
        if (still) {
            setDrawnExpanded(expanded);
            setPhase('still');
        }
        else if (expanded) {
            setDrawnExpanded(true);
            setPhase('unfolding');
        }
        else {
            setPhase('folding');
        }
    }
    useEffect(() => {
        if (phase === 'still')
            return;
        const timer = window.setTimeout(() => {
            if (phase === 'folding')
                setDrawnExpanded(false);
            setPhase('still');
        }, FOLD_MS);
        return () => window.clearTimeout(timer);
    }, [phase]);
    return { drawn: drawnExpanded ? 'expanded' : 'rail', phase };
}
//# sourceMappingURL=motion.js.map